import { useLanguage } from '../context/LanguageContext';

export const translations = {
  en: {
    auth: {
      signInTitle: "Sign In",
      signInSubtitle: "Enter your phone number to continue",
      phoneLabel: "Phone Number",
      phonePlaceholder: "(123) 456-7890",
      continueButton: "Continue",
      selectMethodTitle: "Choose Verification Method",
      selectMethodSubtitle: "How would you like to receive your verification code?",
      textMethod: "Text",
      callMethod: "Call",
      selectMethodDemo: "Both options will work in demo mode",
      verificationTitle: "Verification Code",
      verificationSubtitle: "Enter the 6-digit code sent to your phone",
      codeLabel: "Enter Code",
      codePlaceholder: "Enter 6-digit code",
      verifyButton: "Verify",
      backButton: "Back",
      invalidPhone: "Please enter a valid phone number",
      invalidCode: "Please enter a valid 6-digit code",
      enterFullCode: "Please enter the full 6-digit code.",
      invalidCodeTryAgain: "Invalid verification code. Please try again."
    },
    main: {
      studentView: "Student View",
      activityView: "Activity View", 
      dateView: "Date View",
      viewSettings: "View Settings",
      exportOptions: "Export Options",
      export: "Export",
      print: "Print",
      signOut: "Sign Out",
      noFamilyData: "Could not retrieve family data.",
      lastUpdated: "Last Updated",
      activity: "activity",
      activities: "activities",
      student: "student", 
      students: "students"
    },
    activities: {
      sundaySchool: "Sunday School",
      russianSchool: "Russian School",
      childrensChoir: "Children's Choir"
    },
    details: {
      class: "Class",
      teachers: "Teachers",
      room: "Room",
      classroom: "Classroom",
      choirNumber: "Choir #",
      choirLeaders: "Leaders",
      choirRoom: "Choir Room",
      birthday: "Birthday"
    }
  },
  ru: {
    auth: {
      signInTitle: "Вход",
      signInSubtitle: "Введите ваш номер телефона, чтобы продолжить",
      phoneLabel: "Номер телефона",
      phonePlaceholder: "(123) 456-7890",
      continueButton: "Продолжить",
      selectMethodTitle: "Выберите способ подтверждения",
      selectMethodSubtitle: "Как вы хотите получить код подтверждения?",
      textMethod: "SMS",
      callMethod: "Звонок",
      selectMethodDemo: "Оба варианта работают в демо-режиме",
      verificationTitle: "Код Подтверждения",
      verificationSubtitle: "Введите 6-значный код, отправленный на ваш телефон",
      codeLabel: "Введите Код",
      codePlaceholder: "Введите 6-значный код",
      verifyButton: "Подтвердить",
      backButton: "Назад",
      invalidPhone: "Пожалуйста, введите действительный номер телефона",
      invalidCode: "Пожалуйста, введите действительный 6-значный код",
      enterFullCode: "Пожалуйста, введите полный 6-значный код.",
      invalidCodeTryAgain: "Неверный код подтверждения. Попробуйте еще раз."
    },
    main: {
      studentView: "По ученикам",
      activityView: "По занятиям",
      dateView: "По дням",
      viewSettings: "Настройки просмотра",
      exportOptions: "Параметры экспорта",
      export: "Экспорт",
      print: "Печать",
      signOut: "Выйти",
      noFamilyData: "Не удалось получить данные семьи.",
      lastUpdated: "Последнее обновление",
      activity: "занятие",
      activities: "занятий",
      student: "ученик",
      students: "учеников"
    },
    activities: {
      sundaySchool: "Воскресная школа",
      russianSchool: "Русская школа", 
      childrensChoir: "Детский хор"
    },
    details: {
      class: "Класс",
      teachers: "Учителя",
      room: "Комната",
      classroom: "Класс",
      choirNumber: "Хор №",
      choirLeaders: "Руководители",
      choirRoom: "Комната хора",
      birthday: "День рождения"
    }
  }
};

export const useTranslation = () => {
  const { language } = useLanguage();
  
  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    
    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = value[k];
      } else {
        console.warn(`Translation missing for key: ${key} in language: ${language}`);
        return key; // Return the key if translation is missing
      }
    }
    
    return value;
  };

  return { t };
};
